/**
 * Human-readable labels for scan finding categories.
 * Used in chip strips, filter dropdowns, and scan list cells.
 *
 * CATEGORY_LABEL: finding category key → display string
 * CATEGORY_TO_SCANNER: category → backend scanner name
 * CATEGORY_DESCRIPTION: category → one-line explanation shown in drawer Findings tab
 */
export const CATEGORY_LABEL = {
    pii:              'PII',
    prompt_injection: 'Prompt injection',
    banned_topics:    'Banned topics',
    toxicity:         'Toxicity',
    intent:           'Intent',
};

export const CATEGORY_TO_SCANNER = {
    pii:              'dlp',
    prompt_injection: 'llm_guard',
    banned_topics:    'llm_guard',
    toxicity:         'llm_guard',
    intent:           'intent_classifier',
};

export const CATEGORY_DESCRIPTION = {
    pii:              'Sensitive data pattern matched by DLP.',
    prompt_injection: 'Detected by LLM Guard on prompt input.',
    banned_topics:    'Restricted topic detected by LLM Guard.',
    toxicity:         'Toxic content detected by LLM Guard.',
    intent:           'Malicious intent detected by intent classifier.',
};
